import { ErrorType } from "../../../models/HttpError";
import { Settlement } from "../../../models/Entities/Settlements/Settlement";
import { IDropdownOption } from "@fluentui/react";


// models
import { SettlementDetail } from "../../../models/Entities/SettlementDetails/SettlementDetail";
import { SettlementResume } from "../../../models/Entities/SettlementResume/SettlementResume";

// stores
import * as SettlementDetailsStore from '../../../redux/middleware/SettlementDetailsMiddleware';
import * as SettlementsStore from '../../../redux/middleware/SettlementMiddleware';

//State
import { AppState } from "../../../redux/reducers";


interface IProps {
    isOpen: boolean;
    openPanel: () => void;
    dismissPanel: () => void;
    SettlementId: number;
    SettlementResumeId?: number | undefined | null;
    SettlementDetailId?: number | undefined | null;
}
  
interface ConnectedProps {
    // isAdding: boolean;
    // isSuccessfullyAdded: boolean;
    // failOnAdding: boolean;
    // isUpdating: boolean;
    // isSuccessfullyUpdated: boolean;
    // failOnUpdating: boolean;
    // error: ErrorType | undefined;
    Settlement: Settlement | undefined;
    Summaries: IDropdownOption[];
    SettlementDetail: SettlementDetail | undefined;
}

interface SettlementDispatchProps {
    //AddSettlementDetail: typeof SettlementDetailsStore.actionCreators.AddSettlementDetail;
    //UpdateSettlementDetail: typeof SettlementDetailsStore.actionCreators.UpdateSettlementDetail;
    //ResetStatus: typeof SettlementDetailsStore.actionCreators.ResetStatus;
}

export type Props = IProps & ConnectedProps & SettlementDispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => {

    var SettlementDetailSelected = state.Settlement?.list?.find((settlement: Settlement) => settlement.id === ownProps.SettlementId )?.details?.find((settlementDetail: SettlementDetail) => settlementDetail.id === ownProps.SettlementDetailId);

    return {
        // //adding
        // isAdding: state.SettlementDetails?.isAddingNewOne,
        // isSuccessfullyAdded: state.SettlementDetails?.successAddingNewOne,
        // failOnAdding: state.SettlementDetails?.failOnAddingNewOne,
        
        // // updating
        // isUpdating: state.SettlementDetails?.isUpdatingOne,
        // isSuccessfullyUpdated: state.SettlementDetails?.successUpdatingOne,
        // failOnUpdating: state.SettlementDetails?.failOnUpdatingOne,

        // error: ownProps.SettlementDetailId ? SettlementDetailSelected?.error : state.SettlementDetails?.error,
        
        Settlement: state.Settlement?.list?.find((settlement: Settlement) => settlement.id === ownProps.SettlementId ),
        Summaries: state.Settlement?.list?.find((settlement: Settlement) => settlement.id === ownProps.SettlementId )?.resumes?.map<IDropdownOption[]>((summary: SettlementResume): any => {
         return {key: summary.id,
          text: summary.description}
        }),
        SettlementDetail: SettlementDetailSelected 
    }
};

export const mapDispatchToProps = {
  ...SettlementDetailsStore.actionCreators,
  ...SettlementsStore.actionCreators
};
